import React, { useState,useRef, useEffect } from 'react';
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize
} from '@mui/material';
import useApi from '../../api/useApi';
import { ClassTeacherCreate } from '../../api/teacherService';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router';
import { OrgCreate, StaffCreate } from '../../api/orgService';
// import { Form, TextArea } from 'semantic-ui-react'
// import { useNavigationTab } from '../../hooks/useNavigationTab';


const StaffCreateForm = ({allTopics,allSubtopics,setSelected}) => {
  const navigate = useNavigate()

  const [form, setForm] = useState({
    email: '',
    first_name: '',
    last_name: '',
    middle_name: '',
    user_name: '',
    title:'',
    team:'',
    base:"",
    password:"null",
    description:"null",
    org:1
  });

  const { user } = useAuth();
  // const navigate=useNavigate()
  // const {customNavigate} = useNavigationTab()

  const { request:createStaff,data:createStaffData,error:createStaffError,isLoading:createStaffIsLoading}=useApi(StaffCreate)


  const handleChange = (e) => {
    // setForm({ ...form, [e.target.name]: e.target.value });
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  // const handleFormUrlChange = (e,res) => {
  //   setForm({ ...form, [e.target.name]: res });
  // };

  
 

  useEffect(()=>{
    if(createStaffData){
      if(createStaffData?.status===201){
        toast.success(`${JSON.stringify(createStaffData?.statusText)}, successful`,{position: "top-center"});
        // customNavigate("/t","","home",{refresh:"classes"})
        navigate("/staff/profile/",{state:{redirect:"list-staff"}})
      }
    }
  },[createStaffData])

  useEffect(()=>{
    if(createStaffError){

        toast.error(`${JSON.stringify(createStaffError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[createStaffError])


  const firstPart = form?.first_name?.slice(0, 150);
  const extraPart = form?.first_name?.slice(150);
  const  okayToSubmit = !form.first_name?.length>15 || !form.last_name?.length>0 || !form.team?.length>0 || !form.base?.length>0 || !form.title?.length>0 

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Material Created:', form);
    form.created_by = user?.user?.id
    const dataToSend = {
      email: form.email,
      first_name: form.first_name.slice(0, 150),
      last_name: form.last_name,
    }
    createStaff(form)

    // Add API request logic here
  };
  return (
    <Box display="flex" justifyContent="center" width="100%">
    <Box display="flex" flexDirection="column" justifyContent="center" mt={4} width={700}>

        <div>
          
          <Typography variant="h5" gutterBottom>
            Create a new Staff/Team Member
          </Typography>
        </div>
          
          <Typography variant='p' component="p" color='#404040'>
          Staff and Team members are added here to the system. They will bae able to add activities, projects, campaigns and published to this website through this system.
          </Typography>
          <form onSubmit={handleSubmit} style={{marginTop:30}}>
            
          <i>Required fields are marked with an asterisk (*).</i>

            <TextField
              fullWidth
              label="First Name"
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              label="Last Name"
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              label="Middle Name"
              name="middle_name"
              value={form.middle_name}
              onChange={handleChange}
              margin="normal"
            />

            <TextField
              fullWidth
              label="Staff Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              margin="normal"
              required
              
            />

            <TextField
              fullWidth
              label="Organisation Title"
              name="title"
              value={form.title}
              onChange={handleChange}
              margin="normal"
              required
              
            />

            <TextField
              select
              fullWidth
              label="Organisation Team"
              name="team"
              value={form.team}
              onChange={handleChange}
              margin="normal"
              required
            >
                <MenuItem value="" disabled>
                    -- Select a Team --
                </MenuItem>
                <MenuItem value="Executive Leadership Team">
                Executive Leadership Team
                </MenuItem>
                <MenuItem value="Senior Leadership Team">
                Senior Leadership Team
                </MenuItem>
                <MenuItem value="Board of Management">
                Board of Management
                </MenuItem>
                <MenuItem value="Advisory Committee">
                Advisory Committee
                </MenuItem>
                <MenuItem value="Organisation Team">
                Team Member
                </MenuItem>
            </TextField>

            <TextField
              fullWidth
              label="Location"
              name="base"
              value={form.base}
              onChange={handleChange}
              margin="normal"
              required
              placeholder='Nairobi, Kenya  or Rome, Italy'
            ></TextField>

            {
              form?.team === "Executive Leadership Team"?(
                <TextField
                fullWidth
                label="Executive Leadership Description"
                name="description"
                value={form.description}
                onChange={handleChange}
                margin="normal"
                required
                multiline
                minRows={5}
                rows={5}
              ></TextField>
              ):""

            }

            {/* <Typography variant='p' component="p" color='#404040'>
            Write a brief, informative description that explains about the organisation.
            </Typography>

          <TextField
              fullWidth
              label="Organisation description"
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              margin="normal"
              required
            /> */}
           
           
            {/* <Form>
              <TextArea placeholder='About your organisation ...' 
              name="first_name"
              value={form?.first_name}
              onChange={handleChange} />
            </Form> */}

            {/* <Box
              width="100%"
              height="30%"
              sx={{
                pointerEvents: "none",
                color: "black",
                whiteSpace: "pre-wrap",
                padding: "16.5px 14px",
                fontFamily: "Roboto, sans-serif",
                fontSize: "1rem",
              }}
            >
              {firstPart}
              <span style={{ color: "gray" }}>{extraPart}</span>
            </Box> */}

            
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1 ,mb:5}}
              disabled={okayToSubmit}
            >
              Add Staff
            </Button>
          </form>
      </Box>
    </Box>
  );
};


export default StaffCreateForm